import { render, staticRenderFns } from "./renameFolderModal.vue?vue&type=template&id=475a6c50&"
import script from "./renameFolderModal.vue?vue&type=script&lang=js&"
export * from "./renameFolderModal.vue?vue&type=script&lang=js&"
import style0 from "./renameFolderModal.vue?vue&type=style&index=0&id=475a6c50&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports